import { FormInstance } from "antd";
import { GetPaidInitialData, GetPaidData, GET_PAID_STATUS, GET_PAID_STEP } from "types/get_paid";

export const prefillGetPaidForm = (
  form: FormInstance,
  step: GET_PAID_STEP,
  fields: string[],
  getPaidFilledData: GetPaidData,
) => {
  const values = Object.fromEntries(
    fields.map((fieldName) => {
      const defaultValue = getPaidFilledData?.[fieldName]?.defaultValue;
      const values = getPaidFilledData?.[fieldName]?.values;
      if (defaultValue) {
        if (typeof defaultValue === "object" && "url" in defaultValue) {
          return [fieldName, [defaultValue]];
        } else {
          return [fieldName, defaultValue];
        }
      } else if (values) {
        return [fieldName, values[0]];
      }
      return [fieldName, []];
    })
  ) as GetPaidData;

  form.setFieldsValue({[step]: {...values}});
};

export const sanitizeGetPaidData = (data: GetPaidInitialData[]) => {
  const tahseelBasic = data[0];
  if (!tahseelBasic) {
    return null;
  }

  const getPaidStatus = tahseelBasic.status as GET_PAID_STATUS;

  const preGetPaidData = tahseelBasic.data.main_fields.flatMap(
    (item) => item.fields
  );
  const getPaidData: GetPaidData = {};
  preGetPaidData.forEach((item) => {
    getPaidData[item.key] = {
      key: item.key,
      defaultValue: item.default_value,
      values: item.values?.map((value) => ({
        value: value.key,
        label: value.value,
      })),
    };
  });

  return { getPaidData, getPaidStatus };
};
